import { render, staticRenderFns } from "./ManualApproveButton.vue?vue&type=template&id=7d482362&scoped=true"
import script from "./ManualApproveButton.vue?vue&type=script&lang=js"
export * from "./ManualApproveButton.vue?vue&type=script&lang=js"
import style0 from "./ManualApproveButton.vue?vue&type=style&index=0&id=7d482362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d482362",
  null
  
)

export default component.exports